import React from 'react'
import PropTypes from 'prop-types'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Paper, Grid, Box } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Pie, Chart } from 'react-chartjs-2'

import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../classes/Styles'
import { PORTFOLIO_OVERVIEW } from '../../constants/module_info'
import { NBC_NETWORK, NBC_SHOWS_TO_REMOVE } from '../../constants/labels'
import Thumbnail from '../widgets/Thumbnail'
// import { SPECIAL_LABEL } from '../constants/labels'

export class HomePortfolioComponent extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    homepage: PropTypes.string,
    topicId: PropTypes.string,
    screenWidth: PropTypes.number,
    network: PropTypes.number,
    engagementNetwork: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    })
  }

  constructor (props) {
    super(props)

    this.state = {
      topNetwork: null,
      derivedLabel: '',
      index: -1,
      network: 0,
      label: ''
    }
  }

  componentDidMount () {
    Chart.pluginService.register({
      beforeDraw: function (chart) {
        if (chart.options.centertext) {
          const width = chart.chart.width
          const height = chart.chart.height
          let ctx = chart.chart.ctx;
          ctx.restore();
          ctx.font = '24px Uni Sans Regular'
          ctx.textBaseline = 'middle'
          chart.config.data.datasets.forEach(function (dataset) {
            if (dataset.label === 'TopNetwork') {
              ctx.fillStyle = '#00B5EE'
            } else if (dataset.label === 'Top5Network') {
              ctx.fillStyle = '#0090A7'
            }
          })
          const text = chart.options.centertext
          let textX = Math.round((width - ctx.measureText(text).width) / 2)
          let textY = height / 2;
          ctx.fillText(text, textX, textY);
          ctx.save();
        }
      }
    })
    this.updatedTopNetwork()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.engagementNetwork != this.props.engagementNetwork && this.props.engagementNetwork && this.props.engagementNetwork.details) {
      this.updatedTopNetwork()
    }
  }

  updatedTopNetwork = () => {
    if (this.props.engagementNetwork) {
      const topNetwork = this.props.engagementNetwork.details && this.props.engagementNetwork.details.chart_portfolio_overview.top5_for_category
      const derivedLabel = (this.props.engagementNetwork.details && this.props.engagementNetwork.details.topic.derived_label && this.props.engagementNetwork.details.topic.derived_label.length > 0) && this.props.engagementNetwork.details.topic.derived_label[0][0]
      this.setState({
        topNetwork: topNetwork,
        derivedLabel: derivedLabel
      })
      topNetwork && topNetwork.map((n, i) => {
        if (n.label === derivedLabel) {
          this.setState({
            index: i,
            network: n.score,
            label: n.label
          })
        }
      })
    }
  }

  render () {
    const { classes, homepage, engagementNetwork, screenWidth, topicId } = this.props
    return (
      <Paper className={classes.paper}>
        <Grid container spacing={1} direction="column">
          <Grid item>
            <span className={classes.cardTitle}>Portfolio Overview</span>
            <OverlayTrigger overlay={<Tooltip id="tooltip">{PORTFOLIO_OVERVIEW}</Tooltip>} placement="right">
              <img className={classes.cardInfo} src="/static/images/info.png" alt="info"/>
            </OverlayTrigger>
          </Grid>
          <Grid item className={classes.cardSubTitle}>How {homepage}'s top 5 shows contribute to total network engagement</Grid>
        </Grid>
        { (engagementNetwork && engagementNetwork.isFetching) &&
          <div className='loadingProgress'>
            <CircularProgress />
          </div>
        }
        { (engagementNetwork && engagementNetwork.details) &&
          <Grid container spacing={2} className='portfolioContainer'>
            <Grid item xl={7} lg={7} md={7} sm={6} xs={12}>
              <Grid item container direction="row" justify="space-evenly" alignItems="center" spacing={1} className="portfolio portfolioBorderRight">
                <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
                  <TopNetwork
                    classes={classes}
                    screenWidth={screenWidth}
                    engagementNetwork={engagementNetwork}
                    network={this.state.network}
                    label={this.state.label}
                    changeNetwork={this.changeNetwork}
                  />
                </Grid>
                <Grid item xl={6} lg={6} md={6} sm={6} xs={6} className='top5Network'>
                  <Top5Network homepage={homepage} classes={classes} screenWidth={screenWidth} engagementNetwork={engagementNetwork} />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xl={5} lg={5} md={5} sm={6} xs={12} className={`${classes.portfolioTopContribution} topContribution`}>
              <TopContributingShows
                homepage={homepage}
                classes={classes}
                screenWidth={screenWidth}
                engagementNetwork={engagementNetwork}
                topicId={topicId}
                />
            </Grid>
          </Grid>
        }
      </Paper>
    )
  }

  changeNetwork = (type) => {
    if (type === 'left') {
      let index = this.state.index <= 0 ? this.state.topNetwork.length -1 : this.state.index - 1
      let nextNetwork = this.state.topNetwork[index]
      this.setState({
        index: index,
        network: nextNetwork.score,
        label: nextNetwork.label
      })
    } else if (type === 'right') {
      let index = this.state.index >= this.state.topNetwork.length -1 ? 0 : this.state.index + 1
      let nextNetwork = this.state.topNetwork[index]
      this.setState({
        index: index,
        network: nextNetwork.score,
        label: nextNetwork.label
      })
    }
  }
}

export class TopNetwork extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    screenWidth: PropTypes.number,
    network: PropTypes.number,
    label: PropTypes.string,
    changeNetwork: PropTypes.func,
    engagementNetwork: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    })
  }

  render () {
    const { classes, screenWidth, network, label, changeNetwork } = this.props
    let other = 100 - network
    const data = {
      datasets: [{
        data: [network, other],
        backgroundColor: [
          '#00B5EE',
          '#F4F5F6'
        ],
        borderWidth: 0,
        label: 'TopNetwork'
      }]
    }
    const options = {
      maintainAspectRatio: false,
      responsive: true,
      weight: 1,
      legend: {
        display: false
      },
      tooltips: {
        enabled: false
      },
      cutoutPercentage: 70,
      centertext: `${network}%`
    }
    const onChangeNetwork = (type) => {
      changeNetwork(type)
    }
    const topNetworkClass = screenWidth >= 480 && screenWidth < 563 ? 'portfolioTopNetworkTitle1' : screenWidth >= 1024 && screenWidth < 1236 ? 'portfolioTopNetworkTitle2' : ''
    return (
      <Grid item container direction="column" justify="center" alignItems="center" spacing={1}>
        <Grid item className={classes.portfolioTopNetworkChart}>
          <Box className="pieChartPortfolio">
            <Pie data={data} options={options} width={110} height={110}/>
          </Box>
        </Grid>
        <Grid item className={classes.portfolioTopNetwork}>
          <img className={`${classes.portfolioArrow} cursorPointer`} onClick={() => onChangeNetwork('left')} src="/static/images/portfolioLeftArrow.png" alt="left"/>
          <span className={`${classes.portfolioTopNetworkTitle} ${topNetworkClass}`}>Top 5 {label}</span>
          <img className={`${classes.portfolioArrow} cursorPointer`} onClick={() => onChangeNetwork('right')} src="/static/images/portfolioRightArrow.png" alt="right"/>
        </Grid>
      </Grid>
    )
  }
}

export const Top5Network = ({classes, engagementNetwork, screenWidth}) => {
  const top5Network = engagementNetwork.details && engagementNetwork.details.chart_portfolio_overview && engagementNetwork.details.chart_portfolio_overview.top5_for_current_network
  const network = top5Network ? top5Network.score : 0
  const other = 100 - network
  const data = {
    datasets: [{
      data: [network, other],
      backgroundColor: [
        '#0090A7',
        '#F4F5F6'
      ],
      borderWidth: 0,
      label: 'Top5Network'
    }]
  }
  const options = {
    maintainAspectRatio: false,
    responsive: true,
    weight: 1,
    legend: {
      display: false
    },
    tooltips: {
      enabled: false
    },
    cutoutPercentage: 70,
    centertext: `${network}%`
  }
  const topNetworkClass = screenWidth >= 480 && screenWidth < 563 ? 'portfolioTopNetworkTitle1' : screenWidth >= 1024 && screenWidth < 1236 ? 'portfolioTopNetworkTitle2' : ''
  return (
    <Grid item container direction="column" justify="center" alignItems="center" spacing={1}>
      <Grid item className={classes.portfolioTopNetworkChart}>
        <Box className="pieChartPortfolio">
          <Pie data={data} options={options} width={110} height={110}/>
        </Box>
      </Grid>
      <Grid item className={classes.portfolioTopNetwork}>
        <span className={`${classes.portfolioTop5NetworkTitle} ${topNetworkClass}`}>Top 5 {top5Network && top5Network.label}</span>
      </Grid>
    </Grid>
  )
}

Top5Network.propTypes = {
  classes: PropTypes.object.isRequired,
  homepage: PropTypes.string,
  screenWidth: PropTypes.number,
  engagementNetwork: PropTypes.shape({
    isFetching: PropTypes.bool.isRequired,
    error: PropTypes.object,
    details: PropTypes.object
  })
}

export const TopContributingShows = ({classes, homepage, screenWidth, engagementNetwork, topicId}) => {
  const topContributingShow = engagementNetwork.details && engagementNetwork.details.chart_portfolio_overview && engagementNetwork.details.chart_portfolio_overview.top5_contributing_shows
  topContributingShow && topContributingShow.map(t => t.labels = t.labels.toString())
  let filteredTopContributingShow = topContributingShow //.filter(t => !(t.labels.indexOf(SPECIAL_LABEL) > -1))
  if (topicId === NBC_NETWORK) {
    const showsToHide = NBC_SHOWS_TO_REMOVE.split(',')
    filteredTopContributingShow = filteredTopContributingShow.filter(t => showsToHide.indexOf(t.name) < 0)
  }
  filteredTopContributingShow = filteredTopContributingShow.length > 0 ? filteredTopContributingShow.slice(0, 5) : filteredTopContributingShow
  const charLength = screenWidth < 479.95 ? 35
    : screenWidth > 1360 ? 30 : (screenWidth >= 1024 && screenWidth <= 1030) ? 12 : 15
  const titleWithTooltip = (title) => {
    if (title.length > charLength) {
      const tooltip = <Tooltip id="tooltip">{title}</Tooltip>
      return (
        <OverlayTrigger overlay={tooltip} placement='top'>
          <span>{title.substring(0, charLength)}...</span>
        </OverlayTrigger>
      )
    }
    return (<span>{title}</span>)
  }

  return (
    <Grid item container direction="column" justify="center" spacing={2} className={classes.portfolioTopContributeDiv}>
      <Grid item className={classes.portfolioTopContribute}>
        Top Contributing {homepage} Shows
      </Grid>
      <Grid item>
        <ul className={classes.portfolioTopOrderList}>
          { filteredTopContributingShow && filteredTopContributingShow.map((show, index) => {
            return (
              <li key={show.position} className='homepagePortfolioList'>
                <span className={classes.portfolioTopOrder}>{index + 1}.</span>
                <Thumbnail
                  entityOverrideImage={show.entity_override_image}
                  thumbnail={show.thumbnail}
                  name={show.display_name || show.name}
                  imageSpanClass=''
                  imageClass={classes.portfolioTopImg}
                  noImgTextClass={'homepagePortfolioNoImgText'}
                  noImgClass={'homepagePortfolioNoImg'}
                  divId={`homepage_portfolio_${index}`}
                />
                <span className={classes.portfolioTopText}>{titleWithTooltip(show.display_name || show.name)}</span>
              </li>
              )
            })
          }
        </ul>
      </Grid>
    </Grid>
  )
}

TopContributingShows.propTypes = {
  classes: PropTypes.object.isRequired,
  homepage: PropTypes.string,
  topicId: PropTypes.string,
  screenWidth: PropTypes.number,
  engagementNetwork: PropTypes.shape({
    isFetching: PropTypes.bool.isRequired,
    error: PropTypes.object,
    details: PropTypes.object
  })
}

export default withStyles(styles)(HomePortfolioComponent)